export const useGetCriteriaFromId = (
  allCriteira: ChecklistCriteria[],
  criteriaId: string
) => {
  return allCriteira.find((criteria) => criteria.id === criteriaId);
};
